// @flow

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { insertMaintenanceInformation } from '../../../services/Maintenance/thunks';
import { modifyMaintenanceInformation } from '../../../services/Report/thunks';
import { FormattedMessage, injectIntl } from 'react-intl';
import colors from '../../../styles/colors';
import { Button, Modal, DatePicker } from 'antd';
import { maintenanceInputs } from './MaintenanceInputs';
import moment from 'moment';
import MaintenanceStyle from '../styles';
import { Select, Input, message } from 'antd';
import { isImperial } from 'services/Units/thunks';
const ParticularMaintenance = (props) => {
    const { TextArea } = Input;
    const { editData } = props;
    const [maintenanceInformation, setMaintenanceInformation] = useState({
        date_extra_maint: new Date().toISOString(),
        date_entrance_extra_maint: new Date().toISOString(),
        date_exit_extra_maint: new Date().toISOString(),
        departement_extra_maint: '',
        sector_extra_maint: '',
        garage_name_extra_maint: '',
        technician_name_extra_maint: '',
        odometer: null,
        horometer: null,
        veh_type_extra_maint: '',
        cost_extra_maint: '',
        invoice_number_extra_maint: '',
        repair_type_extra_maint: '',
        comment_extra_maint: '',
    });

    const [image, setImage] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = () => {
            setImage(reader.result); // This is the base64 string
        };

        reader.readAsDataURL(file); // This converts to base64
    };

    useEffect(
        () => {
            if (editData) {
                const horometer =
                    editData.get('Horometre') !== null
                        ? (parseFloat(editData.get('Horometre')) / 3600).toFixed(2)
                        : null;
                const conversionFactor = props.isImperial() ? 1609.344 : 1000;
                const odometer = editData.get('Odometre')
                    ? (parseFloat(editData.get('Odometre')) / conversionFactor).toFixed(2)
                    : null;
                setMaintenanceInformation({
                    date_extra_maint: editData.get('Date'),
                    date_entrance_extra_maint: editData.get('DateEntree'),
                    date_exit_extra_maint: editData.get('DateSortie'),
                    departement_extra_maint: editData.get('Departement'),
                    sector_extra_maint: editData.get('Sector'),
                    garage_name_extra_maint: editData.get('Garage'),
                    odometer: odometer,
                    horometer: horometer,
                    veh_type_extra_maint: editData.get('TypeVehicule'),
                    technician_name_extra_maint: editData.get('technicianName'),
                    cost_extra_maint: editData.get('Cout'),
                    invoice_number_extra_maint: editData.get('NumeroDeFacture'),
                    repair_type_extra_maint: editData.get('TypeReparation'),
                    comment_extra_maint: editData.get('EntretienCommentaire'),
                });
            }
        },
        [editData]);
    useEffect(
        () => {
            if (props.selectedVehicle) {
                const horometer = (props.selectedVehicle.horometer / 3600).toFixed(2);
                const conversionFactor = props.isImperial() ? 1609.344 : 1000;
                const odometer = (
                    Math.floor((props.selectedVehicle.odometer / conversionFactor) * 100) / 100
                ).toFixed(2);

                setMaintenanceInformation({
                    ...maintenanceInformation,
                    odometer: odometer,
                    horometer: horometer,
                });
            }
        },
        [props.selectedVehicle]
    );
    const successNotif = (msg) => {
        message.success(msg, 2);
    };

    const failureNotif = (msg) => {
        message.warning(msg, 2);
    };

    const handleSetMaintenance = (event, item) => {
        let obj = maintenanceInformation;
        obj[item.type] =
            item.InputType === 'Date' ? moment(event).format('YYYY-MM-DD HH:mm:ss') : event;
        setMaintenanceInformation({ ...obj });
    };
    useEffect(
        () => {
            console.log('maintenanceInformation', maintenanceInformation);
        },
        [maintenanceInformation]
    );
    const handleApplyChanges = async () => {
        maintenanceInformation.horometer !== null
            ? (maintenanceInformation.horometer =
                  parseFloat(maintenanceInformation.horometer).toFixed(2) * 3600)
            : null;
        maintenanceInformation.odometer !== null
            ? (maintenanceInformation.odometer =
                  parseFloat(maintenanceInformation.odometer).toFixed(2) *
                  (props.isImperial() ? 1609.344 : 1000))
            : null;
        if (editData) {
            editData.get('id');
            props
                .modifyMaintenanceInformation(editData.get('id'), maintenanceInformation)
                .then(() => {
                    successNotif(
                        props.intl.formatMessage({
                            id:
                                'containers.Maintenance.VehicleDetail.Notif.updateInformationMaintenance',
                        })
                    );
                    props.handleCancelMaintenance();
                })
                .catch(() => {
                    failureNotif(
                        props.intl.formatMessage({
                            id: 'containers.Maintenance.Notif.Error',
                        })
                    );
                });
            return;
        }

        await props
            .insertMaintenanceInformation(props.selectedVehicle.id, maintenanceInformation)
            .then(() => {
                successNotif(
                    props.intl.formatMessage({
                        id:
                            'containers.Maintenance.VehicleDetail.Notif.updateInformationMaintenance',
                    })
                );
                props.handleCancelMaintenance();
            })
            .catch(() => {
                failureNotif(
                    props.intl.formatMessage({
                        id: 'containers.Maintenance.Notif.Error',
                    })
                );
            });
    };

    return (
        <div>
            <Modal
                title={props.intl.formatMessage({
                    id: 'containers.Maintenance.MaintenancePlus.Info',
                })}
                visible={props.isModalMaintenanceOpen}
                onCancel={props.handleCancelMaintenance}
                footer={[
                    <Button
                        key="cancel"
                        type="primary"
                        onClick={props.handleCancelMaintenance}
                        style={{
                            backgroundColor: colors.redA,
                            borderColor: colors.redA,
                        }}
                    >
                        <FormattedMessage id={'containers.Maintenance.Modal.Cancel'} />
                    </Button>,
                    <Button
                        key="confirmer"
                        type="primary"
                        onClick={handleApplyChanges}
                        style={{
                            backgroundColor: colors.green57,
                            borderColor: colors.green57,
                        }}
                    >
                        <FormattedMessage id={'containers.Maintenance.Modal.Confirm'} />
                    </Button>,
                ]}
            >
                <div>
                    {maintenanceInputs.map((item) => {
                        const label = (
                            <FormattedMessage
                                id={'containers.Maintenance.MaintenancePlus.' + item.type}
                            />
                        );
                        switch (item.InputType) {
                            case 'Date':
                                return (
                                    <div key={item.type}>
                                        <MaintenanceStyle.MaintenanceInput>
                                            {label}
                                            <DatePicker
                                                defaultValue={moment(
                                                    maintenanceInformation[item.type],
                                                    'YYYY-MM-DD'
                                                )}
                                                format={'YYYY-MM-DD'}
                                                onChange={(event) =>
                                                    handleSetMaintenance(
                                                        event !== null ? event._d : new Date(),
                                                        item
                                                    )
                                                }
                                            />
                                        </MaintenanceStyle.MaintenanceInput>
                                    </div>
                                );

                            case 'text':
                            case 'number':
                                return (
                                    <div key={item.type}>
                                        <MaintenanceStyle.MaintenanceInput>
                                            {label}
                                            <MaintenanceStyle.InputItem
                                                value={maintenanceInformation[item.type]}
                                                type={item.InputType}
                                                step={'0.01'}
                                                onChange={(event) =>
                                                    handleSetMaintenance(event.target.value, item)
                                                }
                                            />
                                        </MaintenanceStyle.MaintenanceInput>
                                    </div>
                                );

                            case 'Select':
                                return (
                                    <div key={item.type}>
                                        <MaintenanceStyle.MaintenanceInput>
                                            {label}
                                            <MaintenanceStyle.Select
                                                defaultValue={maintenanceInformation[item.type]}
                                                onChange={(event) =>
                                                    handleSetMaintenance(event, item)
                                                }
                                            >
                                                {item.values.map(
                                                    (itemOption) =>
                                                        itemOption !== '' ? (
                                                            <Select.Option
                                                                key={itemOption}
                                                                value={itemOption}
                                                            >
                                                                <FormattedMessage
                                                                    id={
                                                                        'containers.Maintenance.MaintenancePlus.' +
                                                                        itemOption
                                                                    }
                                                                />
                                                            </Select.Option>
                                                        ) : (
                                                            <Select.Option key={''} value={''} />
                                                        )
                                                )}
                                            </MaintenanceStyle.Select>
                                        </MaintenanceStyle.MaintenanceInput>
                                    </div>
                                );
                            case 'textArea':
                                return (
                                    <div key={item.type}>
                                        <MaintenanceStyle.MaintenanceInput>
                                            {label}
                                            <TextArea
                                                value={maintenanceInformation[item.type]}
                                                className={'textAreaInput'}
                                                rows={3}
                                                onChange={(event) =>
                                                    handleSetMaintenance(event.target.value, item)
                                                }
                                            />
                                        </MaintenanceStyle.MaintenanceInput>
                                    </div>
                                );
                        }
                    })}
                </div>
            </Modal>
        </div>
    );
};

// REDUX
/**
 *
 */
const mapStateToProps = createStructuredSelector({});

/**
 *
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ insertMaintenanceInformation, modifyMaintenanceInformation,isImperial }, dispatch);

// EXPORTS
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(ParticularMaintenance));
